// extracted by mini-css-extract-plugin
export var reactIcons = "components-module--react-icons--CIQBP";
export var iconsExtraSmall = "components-module--icons-extra-small--LzSVx";
export var iconsSmall = "components-module--icons-small--50Ru2";
export var iconsMedium = "components-module--icons-medium--rIsb1";
export var iconsBig = "components-module--icons-big--PTGcI";
export var faIcons = "components-module--fa-icons--0SjjB";
export var contentList = "components-module--content-list--JpN3b";